import { BaseTable, Loading, TableHeader } from "components";
import moment from "moment";
import { Fragment } from "react";
import { APPROVAL, convertNumber } from "utils";
import { useList } from "./utils";

export function TabAdjusment(props: {
    dateFrom: string;
    dateEnd: string;
}): JSX.Element {
    const productId = localStorage.getItem("prdId")

    const {data, isLoading} = useList({
            start_date: props.dateFrom, 
            end_date: props.dateEnd,
            product_id: Number(productId)
        });

    const totalStockIn = data.reduce((acc, val) => acc + Number(val.stock_in), 0);
    const totalStockOut = data.reduce((acc, val) => acc + Number(val.stock_out), 0);
    const totalAmount = data.reduce((acc, val) => acc + Number(val.amount_adjustment), 0);

    return (
        <Fragment>
            <section className="mt-2">
                <div className="overflow-x-auto">
                    <BaseTable className="border-transparent">
                        <TableHeader>
                            <tr className="uppercase">
                                <th>No</th>
                                <th>ADJUSTMENT ID#</th>
                                <th>DATE</th>
                                <th>LOCATION</th>
                                <th>APPROVED</th>
                                <th>SOURCE</th>
                                <th>STOCK IN</th>
                                <th>STOCK OUT</th>
                                <th>AMOUNT ADJUSTMENT</th>
                            </tr>
                        </TableHeader>
                        <tbody>
                            {!data.length || isLoading
                                ? <tr><td colSpan={9} className="text-center"><Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} /></td></tr>
                                : data.map((val, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{val?.trx_code ?? ""}</td>
                                        <td>{moment(val?.transaction_date).format("DD/MM/YYYY")}</td>
                                        <td>{val.location_name}</td>
                                        <td>{APPROVAL[val?.approve_status]}</td>
                                        <td>{val.source === 1 ? "COUNT ADJUSTMENT" : "DIRECT ADJUSTMENT"}</td>
                                        <td className="text-center">{val.stock_in ? convertNumber(Number(val.stock_in)).intoNormalAmount : ""}</td>
                                        <td className="text-center">{val.stock_out ? `${convertNumber(Number(val.stock_out))?.intoNormalAmount}` : ""}</td>
                                        <td className="text-right">{val.amount_adjustment ? convertNumber(Number(val.amount_adjustment))?.intoCurrency : ""}</td>
                                    </tr>
                                ))
                            }

                             <tr className="font-bold">
                                <td colSpan={6} className="text-right">SUMMARY</td>
                                <td className="text-center">{totalStockIn ? `${convertNumber(totalStockIn)?.intoNormalAmount}` : "0"}</td>
                                <td className="text-center">{totalStockOut ? `${convertNumber(totalStockOut)?.intoNormalAmount}` : "0"}</td>
                                <td className="text-right">{totalAmount ? convertNumber(totalAmount)?.intoCurrency : "0"}</td>
                            </tr>
                        </tbody>
                        <tfoot >
                           
                        </tfoot>
                    </BaseTable>
                </div>
            </section>
        </Fragment>
    )
}